import lod_ from "lodash";
import React, { useEffect, useState } from "react";
import { Badge, Icon, List, ListItem, Switch, Box } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import ListItemText from "@material-ui/core/ListItemText";
import { connect, useDispatch, useSelector } from "react-redux";
import { compose } from "redux";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import { NavLink } from "react-router-dom";
import cx from "classnames";
import { useAuth0 } from "react-auth0-wrapper";
import PowerSettingsNewOutlinedIcon from "@material-ui/icons/PowerSettingsNewOutlined";
import { Dashboard, Settings, Brightness4, Brightness7 } from "@material-ui/icons";
import Cookies from "universal-cookie";
import newsActions from "../../redux/actions/newsActions";
import { useTheme } from "../../theme";
import Notifications from "components/Notifications";

const toAdmin = process.env.REACT_APP_ADMINMANAGER;
const toAnalytics = process.env.REACT_APP_ANALYTICS;
const cookies = new Cookies();

function SettingsMenu(props) {
	const dispatch = useDispatch();
	const { classes, state } = props;
	const { logout } = useAuth0();
	const selectedAssistantID = useSelector(state => state.selectedAssistantID);
	const { isDarkMode, toggleTheme } = useTheme();

	const role = props.userStatus && props.userStatus.auth && props.userStatus.auth.user.role;

	function redirectToAdmin() {
		let loader = document.getElementsByTagName("BODY")[0];
		loader.className = "loading";
		setTimeout(() => {
			loader.className = "";
		}, 3000);
		window.open(toAdmin, "_blank");
	}
	function redirectToAnalytics() {
		let loader = document.getElementsByTagName("BODY")[0];
		loader.className = "loading";
		setTimeout(() => {
			loader.className = "";
		}, 3000);
		window.open(toAnalytics, "_blank");
	}

	function logOutUser() {
		cookies.remove("fAIbrik.selectedAssistantID");
		logout({ returnTo: window.location.origin });
	}

	const navLinkClasses = classes.itemLink;

	const itemText =
		classes.itemText +
		" " +
		cx({
			[classes.itemTextMini]: state?.miniActive
		});

	/**
	 * Check if the route is active
	 * @param {string} routeName - The name of the route
	 * @returns {boolean} - True if the route is active, false otherwise
	 */
	function activeRoute(routeName) {
		return window.location.pathname === `/admin${routeName}` ? "active" : "";
	}

	/**
	 * Class for the news link
	 */
	const newsClasses =
		classes.itemLink +
		cx({
			[" " + classes["blue"]]: activeRoute("/news")
		});

	const [userHasUnreadNews, setUserHasUnreadNews] = useState(false);

	/**
	 * When the user clicks on the news link, we save the current date in local storage
	 * to know when the user last read the news.
	 * This is used to show the news as read or unread.
	 */
	const saveLastDateReadNews = () => {
		const userID = props.userStatus.auth.user.email;
		const lastDateRead = new Date().getTime();
		localStorage.setItem(`lastDateReadNews_${userID}_${selectedAssistantID}`, lastDateRead);
		setUserHasUnreadNews(false);
	};

	/**
	 * On component mount, we check if the user has unread news.
	 * If the user has unread news, we set the state to true.
	 */
	const checkForUnreadNews = () => {
		const userID = props.userStatus.auth.user.email;
		const lastDateRead = localStorage.getItem(`lastDateReadNews_${userID}_${selectedAssistantID}`);

		if (lod_.isNil(lastDateRead)) {
			setUserHasUnreadNews(true);
			return;
		}

		// Check from the back if there are unread news
		dispatch(
			newsActions.checkForUnreadNews(selectedAssistantID, Number(lastDateRead), res => {
				const count = res.count || 0;
				if (count > 0) {
					setUserHasUnreadNews(true);
				} else {
					setUserHasUnreadNews(false);
				}
			})
		);
	};

	/**
	 * On component mount, we check if the user has unread news.
	 */
	useEffect(() => {
		if (lod_.isNil(props?.userStatus?.auth?.user?.email) || lod_.isNil(selectedAssistantID)) {
			return;
		}
		checkForUnreadNews();
	}, [selectedAssistantID, props?.userStatus?.auth?.user?.email]);

	return (
		<>
			<List className={classes.collapseList} component="div" disablePadding>
				<Notifications classes={classes} boxClasses={classes.itemLink} itemText={itemText} />

				<ListItem className={classes.item}>
					<NavLink className={newsClasses} to="/admin/news" onClick={saveLastDateReadNews}>
						<Badge
							className={classes.itemIcon}
							color="error"
							overlap="circular"
							variant="dot"
							invisible={!userHasUnreadNews}
						>
							<Icon className={classes.itemIcon} style={{ color: "white" }}>
								<NotificationsNoneOutlinedIcon />
							</Icon>
						</Badge>

						<ListItemText
							className={itemText}
							disableTypography={true}
							primary={"Actualités"}
							style={{ color: "white" }}
						/>
					</NavLink>
				</ListItem>

				{role && (role === "supervisor" || role === "administrator" || role === "soloUser") && (
					<ListItem className={classes.item}>
						<NavLink className={navLinkClasses} to={"#"} onClick={() => redirectToAdmin()}>
							<Icon className={classes.itemIcon} style={{ color: "white" }}>
								<Settings />
							</Icon>
							<ListItemText
								className={itemText}
								disableTypography={true}
								primary={"Config"}
								style={{ color: "white" }}
							/>
						</NavLink>
					</ListItem>
				)}
				{role && (
					<ListItem className={classes.item}>
						<NavLink className={navLinkClasses} to={"#"} onClick={() => redirectToAnalytics()}>
							<Icon className={classes.itemIcon} style={{ color: "white" }}>
								<Dashboard />
							</Icon>
							<ListItemText
								className={itemText}
								disableTypography={true}
								primary={"Analytics"}
								style={{ color: "white" }}
							/>
						</NavLink>
					</ListItem>
				)}
				<ListItem className={classes.item}>
					<NavLink className={navLinkClasses} to={"#"} onClick={() => logOutUser()}>
						<Icon className={classes.itemIcon} style={{ color: "white" }}>
							<PowerSettingsNewOutlinedIcon />
						</Icon>
						<ListItemText
							className={itemText}
							disableTypography={true}
							primary={props.t("manageButton.logout")}
							style={{ color: "white" }}
						/>
					</NavLink>
				</ListItem>
			</List>
		</>
	);
}

function mapStateToProps(state) {
	return state;
}

export default compose(
	withTranslation(),

	connect(mapStateToProps)
)(SettingsMenu);
